import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GridColDef, GridRowModel } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router";
import { GET_SESSIONS } from "../../../features/graphql/query";
import { useLocation } from "../../../context/LocationContext";
import { useCompany } from "../../../context/CompanyContext";
import { TableToolBarStacked, useManageModal, TablePaginated, SessionFilterOption } from "ui";
import { format } from "date-fns";
import { FetchMoreCallbackArgs } from "ui/components/Tables";
import { TagsCell } from "./TagsCells";
const DEFAULT_PAGE_SIZE = 5
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "createdAt", headerName: "Sesison Date", flex: .5,

    }, {
        field: "sessionType", headerName: "Session Type", flex: 1,
    },
    {
        field: "launchedBy", headerName: "Launched by", flex: 1
    },
    { field: "studentId", headerName: "Student Id", flex: 1 },
    {
        field: "data", headerName: "Data", flex: 1.5, headerAlign: 'center',
        renderCell(params) {
            return (
                <TagsCell flags={params.row?.data
                    ? JSON.parse(params.row?.data)?.tags
                    : null} />
            )
        }
    }
]

function mapEdgesToTable(data: any) {
    const session = { ...data.node }
    return {
        ...session,
        createdAt: format(new Date(session.createdAt), "MM/dd/yyyy"),
        sessionType: `${session?.category} ${session?.language} ${session?.type}`,
        launchedBy: `${session?.person?.firstName} ${session?.person?.lastName}`,
        location: `${session?.location?.name}`
    }
}
export function SessionTable({ onBack }: { onBack: () => void }) {
    // const { id } = useParams()
    // const {data,loading,fetchMore} = useQuery(GET_SESS)
    const { id } = useParams()
    const windowLocation = window.location.pathname.includes("location") ? "location" : window.location.pathname.includes("company") ? "company" : "all"
    const navigate = useNavigate();
    const [tableFilter, setTableFilter] = useState("ALL")
    const [pageLoading, setPageLoading] = useState<boolean>(true)
    const { data, loading, fetchMore } = useQuery(GET_SESSIONS, {
        variables: {
            searchCriteria: windowLocation,
            searchId: id ?? '',
            first: DEFAULT_PAGE_SIZE,
            query: "",
            after: null
        }
    })
    const { openModal } = useManageModal()
    const { location } = useLocation()
    const { company } = useCompany()
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[]
        filteredRows: GridRowModel[],
        title: string,
        subtitle: string | undefined,
        status: 'NORMAL' | "FILTERING"
    }>({ columns: [], rows: [], filteredRows: [], status: "NORMAL", title: "", subtitle: "" })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = data?.sessionsByCondition?.edges.map(mapEdgesToTable) ?? []
            const _title = 'Sessions'
            const _subTitle = windowLocation == "location" ? `@${location?.name}` : windowLocation == "company" ? `@${company?.name}` : '';
            if (windowLocation != "location") {
                columns.push({
                    field: "location", headerName: "Location",

                })
            }
            if (data) {
                setPageLoading(false)
            }
            return {
                ...prevState,
                columns,
                filteredRows: [],
                rows,
                title: _title,
                subtitle: _subTitle
            }
        })
    }, [data, loading])
    const handleFilter = (option: SessionFilterOption) => {
        setTableFilter(option)
        fetchMore({
            variables: {
                searchCriteria: windowLocation,
                searchId: id ?? "",
                first: DEFAULT_PAGE_SIZE,
                query: "",
                after: null,
                sessionType: option as SessionFilterOption
            }
        })
    }
    const handleFetchMore = async (variables: FetchMoreCallbackArgs) => {
        await fetchMore({
            variables: {
                searchCriteria: windowLocation,
                searchId: id ?? "",
                first: variables.first ?? DEFAULT_PAGE_SIZE,
                query: variables.query ?? "",
                after: variables.after ?? null,
                sessionType: tableFilter
            }
        }).then((res) => {
            const rows = res?.data?.sessionsByCondition?.edge?.map(mapEdgesToTable) ?? []
            if (rows && rows.length > 0) {
                setPageTableState(prevState => ({
                    ...prevState,
                    rows
                }))
            }
        })
    }
    return (
        <TablePaginated
            loading={loading || pageLoading}
            autoHeight
            rows={pageLoading ? [] : pageTableState.rows}
            columns={pageTableState.columns}
            renderToolbar={({ searchQuery, onSearch, onSearchClear }) => (
                <TableToolBarStacked
                    title={pageTableState.title}
                    subTitle={pageTableState.subtitle}
                    onBack={onBack}
                    onFilter={handleFilter}
                    limitFilter={true}
                    filterTableName="sessions"
                    onSearchClear={onSearchClear}
                    onSearch={onSearch}
                    searchQuery={searchQuery ?? ''}
                />
            )}
            pageInfo={data?.sessionsByCondition?.pageInfo}
            totalRows={data?.sessionsByCondition?.totalCount}
            pageSize={DEFAULT_PAGE_SIZE}
            filterParams={{ filterType: "sessionType", filter: tableFilter }}
            onFetchMore={handleFetchMore}
            disableBoxShadow
        />
    )
}